export const parseTurndownPayload = state => {
  const { typeId } = state.turndown;
  return {
    requestId: state.requests.request.id,
    typeId,
  };
};
